import { Link } from 'react-router-dom'
import type { NavItem } from './Header'

interface FooterProps {
  logoText?: string
  tagline?: string
  nav?: NavItem[]
  phone?: string
  email?: string
  address?: string
  legalName?: string
}

export function Footer({ logoText, tagline, nav = [], phone, email, address, legalName }: FooterProps) {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="container-content py-12 md:py-16 grid gap-10 md:grid-cols-3">
        <div>
          <p className="font-heading font-bold text-lg text-white">{logoText}</p>
          {tagline && <p className="mt-2 text-sm">{tagline}</p>}
        </div>
        {nav.length > 0 && (
          <nav aria-label="Footer navigation">
            <ul className="space-y-2">
              {nav
                .flatMap((item) => (item.children?.length ? item.children : [item]))
                .filter((item) => item.href)
                .map((item) => (
                  <li key={item.href}>
                    <Link to={item.href!} className="text-sm hover:text-white transition-colors">
                      {item.label}
                    </Link>
                  </li>
                ))}
            </ul>
          </nav>
        )}
        <address className="not-italic text-sm space-y-2">
          {address && <p>{address}</p>}
          {phone && <p><a href={`tel:${phone.replace(/\s/g, '')}`} className="hover:text-white">{phone}</a></p>}
          {email && <p><a href={`mailto:${email}`} className="hover:text-white">{email}</a></p>}
        </address>
      </div>
      <div className="border-t border-white/10">
        <div className="container-content py-4 text-xs text-gray-500">
          © {new Date().getFullYear()} {legalName ?? logoText}. All rights reserved.
        </div>
      </div>
    </footer>
  )
}
